"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = exports.DESKTOP_DISPLAY = exports.MOBILE_DISPLAY = exports.STRIP_HEIGHT = exports.STRIP_PADDING = exports.OUT_SCENE_EFFECT = exports.IN_SCENE_EFFECT = exports.BACKGROUND_COLOR = exports.SORTING_WAYS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.style-utils");

var _gerenciatdUnifiedicons = _interopRequireDefault(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

require("./ActionStrip.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const SORTING_WAYS = {
  ICON_RIGHT: 'icon-right',
  ICON_LEFT: 'icon-left'
};
exports.SORTING_WAYS = SORTING_WAYS;
const BACKGROUND_COLOR = {
  GREY1A: 'grey1a',
  GREEN: 'green',
  BLUE_DARK: 'blue-dark',
  GREY6: 'grey6',
  ORCHID_LIGHT: 'orchid-light',
  EGG: 'egg'
};
exports.BACKGROUND_COLOR = BACKGROUND_COLOR;
const IN_SCENE_EFFECT = {
  FADE_IN_FROM_TOP: 'fadeInFromTop'
};
exports.IN_SCENE_EFFECT = IN_SCENE_EFFECT;
const OUT_SCENE_EFFECT = {
  FADE_OUT_FROM_TOP: 'fadeOutFromTop'
};
exports.OUT_SCENE_EFFECT = OUT_SCENE_EFFECT;
const STRIP_PADDING = {
  DEFAULT: 'default',
  EMP: 'emp'
};
exports.STRIP_PADDING = STRIP_PADDING;
const STRIP_HEIGHT = {
  DEFAULT: 'default',
  EMP: 'emp'
};
exports.STRIP_HEIGHT = STRIP_HEIGHT;
const MOBILE_DISPLAY = {
  ROW: 'row',
  COLUMN: 'column'
};
exports.MOBILE_DISPLAY = MOBILE_DISPLAY;
const DESKTOP_DISPLAY = {
  ALL_WIDTH: 'all-width',
  AUTO: 'auto'
};
exports.DESKTOP_DISPLAY = DESKTOP_DISPLAY;
const COMPONENT_NAME = 'ActionStrip';
exports.COMPONENT_NAME = COMPONENT_NAME;

class ActionStrip extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "componentDidUpdate", () => {
      const {
        unMounted,
        show
      } = this.state;

      if (!show && !unMounted) {
        const transitionEvent = (0, _gerenciatdUtils.whichAnimationEvent)();
        const element = document.getElementById('ActionStrip_animationReference');

        if (transitionEvent) {
          element.addEventListener(transitionEvent, () => {
            this.setState({
              unMounted: true
            });
          });
        }
      }
    });

    _defineProperty(this, "handleClose", () => {
      this.setState({
        show: false
      });
    });

    _defineProperty(this, "setEffect", () => {
      const {
        inSceneEffect,
        ouSceneEffect
      } = this.props;
      const {
        show
      } = this.state;
      let effectRes = inSceneEffect;

      if (!show) {
        effectRes = ouSceneEffect;
      }

      return ` ActionStrip_effect--${effectRes}`;
    });

    this.state = {
      unMounted: false,
      show: true
    };
  }

  render() {
    const {
      unMounted
    } = this.state;
    const {
      components,
      className,
      backgroundColor,
      sort,
      stripPadding,
      mobileDisplay,
      stripHeight,
      desktopDisplay,
      taggingInfo
    } = this.props;

    const mainTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
      componentName: COMPONENT_NAME,
      componentProduct: '',
      componentVariation: 'all'
    });

    const ownCss = className ? ` ${className}` : '';
    const effect = this.setEffect();
    const containerResponsiveCss = `containerActionStrip--mobileDisplay-${mobileDisplay} containerActionStrip--desktopDisplay-${desktopDisplay}`;

    if (unMounted || !components) {
      return null;
    }

    let customIconCss = 'customicon';

    if (components['SvgIconLoader-2'] && components['SvgIconLoader-2'].className) {
      customIconCss = `${components['SvgIconLoader-2'].className} ${customIconCss}`;
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: 'ActionStrip_animationReference',
      className: `ActionStrip ActionStrip_stripHeight-${stripHeight} ActionStrip_sort--${sort} ActionStrip_bgColor--${backgroundColor}${ownCss}${effect}`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `container containerActionStrip containerActionStrip--stripPadding-${stripPadding} ${containerResponsiveCss}`,
        children: [components && components['SvgIconLoader-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `ActionStrip_closeGap ActionStrip_closeGap--mobileDisplay-${mobileDisplay} ActionStrip_closeGap--desktopDisplay-${desktopDisplay}`,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "XIcon_Gap",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
              className: "test",
              onClick: this.handleClose,
              taggingInfo: _objectSpread(_objectSpread({}, mainTaggingInfo), {}, {
                componentContent: 'cerrar'
              }),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, components['SvgIconLoader-1']), {}, {
                className: "cerrar"
              }))
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `ActionStrip_contentGap ActionStrip_contentGap--mobileDisplay-${mobileDisplay} ActionStrip_contentGap--desktopDisplay-${desktopDisplay}`,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "TextInfoContainer",
            children: [components && components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['TextInfo-1'])), components && components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread({}, components['TextInfo-2']))]
          }), components && components['SvgIconLoader-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "ActionStrip_contentSvg",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread(_objectSpread({}, components['SvgIconLoader-2']), {}, {
              className: customIconCss
            }))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `ActionStrip_buttonGap ActionStrip_buttonGap--mobileDisplay-${mobileDisplay}`,
          children: [components && components['SvgIconLoader-3'] && !components['Button-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread({}, components['SvgIconLoader-3'])), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              width: '100%'
            },
            children: components && components['Button-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({
              taggingInfo: _objectSpread(_objectSpread({}, mainTaggingInfo), {}, {
                componentContent: 'iniciar-sesion'
              })
            }, components['Button-1']))
          })]
        })]
      })
    });
  }

}

ActionStrip.WaitingComponent = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLoadingSkeleton.default, {
  count: 1,
  height: 100
});

ActionStrip.propTypes = {
  components: _propTypes.default.object,
  className: _propTypes.default.string,
  backgroundColor: _propTypes.default.oneOf([BACKGROUND_COLOR.BLUE_DARK, BACKGROUND_COLOR.GREEN, BACKGROUND_COLOR.GREY1A, BACKGROUND_COLOR.GREY6, BACKGROUND_COLOR.ORCHID_LIGHT, BACKGROUND_COLOR.EGG]),
  inSceneEffect: _propTypes.default.oneOf([IN_SCENE_EFFECT.FADE_IN_FROM_TOP]),
  ouSceneEffect: _propTypes.default.oneOf([OUT_SCENE_EFFECT.FADE_OUT_FROM_TOP]),
  sort: _propTypes.default.oneOf([SORTING_WAYS.ICON_LEFT, SORTING_WAYS.ICON_RIGHT]),

  /**
   * {
   *  "info": "Padding de la caja del action strip, por defecto es un mínimo de 69px",
   *  "kind": "both",
   *  "beautifulName": "stripPadding"
   * }
   */
  stripPadding: _propTypes.default.oneOf([STRIP_PADDING.DEFAULT, STRIP_PADDING.EMP]),

  /**
   * {
   *  "info": "Altura de la caja del action strip",
   *  "kind": "both",
   *  "beautifulName": "stripPadding"
   * }
   */
  stripHeight: _propTypes.default.oneOf([STRIP_HEIGHT.DEFAULT, STRIP_HEIGHT.EMP]),

  /**
   * {
   *  "info": "Diseño móvil de la caja, por defecto es row",
   *  "kind": "both",
   *  "beautifulName": "stripPadding"
   * }
   */
  mobileDisplay: _propTypes.default.oneOf([MOBILE_DISPLAY.ROW, MOBILE_DISPLAY.COLUMN]),

  /**
   * {
   *  "info": "Diseño desktop de la caja, por defecto es auto",
   *  "kind": "both",
   *  "beautifulName": "stripPadding"
   * }
   */
  desktopDisplay: _propTypes.default.oneOf([DESKTOP_DISPLAY.AUTO, DESKTOP_DISPLAY.ALL_WIDTH]),

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object.isRequired
};
ActionStrip.defaultProps = {
  components: null,
  className: '',
  backgroundColor: BACKGROUND_COLOR.GREY1A,
  inSceneEffect: IN_SCENE_EFFECT.FADE_IN_FROM_TOP,
  ouSceneEffect: OUT_SCENE_EFFECT.FADE_OUT_FROM_TOP,
  sort: SORTING_WAYS.ICON_LEFT,
  stripPadding: STRIP_PADDING.DEFAULT,
  stripHeight: STRIP_HEIGHT.DEFAULT,
  mobileDisplay: MOBILE_DISPLAY.ROW,
  desktopDisplay: DESKTOP_DISPLAY.AUTO
};
var _default = ActionStrip;
exports.default = _default;

//# sourceMappingURL=index.js.map